export default {
	ADD_BREAK(state, item) {
		state.breaks.push(item);
	},
	SET_BREAKS(state, breaks) {
		state.breaks = breaks;
		state.totalBreaks = breaks.length;
	},
	UPDATE_BREAK(state, product) {
		const productIndex = state.breaks.findIndex((p) => p.id === product.id);
		Object.assign(state.breaks[productIndex], product);
	},
	REMOVE_BREAK(state, itemId) {
		const ItemIndex = state.breaks.findIndex((p) => p.id === itemId);
		state.breaks.splice(ItemIndex, 1);
	},
	SET_CRON_EXPRESSION(state, item) {
		state.cronExpression = item;
	},
	SET_BREAKS_FILTER(state, breaks) {
		state.breaks = [...breaks];
	},
	ADD_ASSIGNED_BREAKS(state, breaks) {
		let newList;
		if (Array.isArray(teams)) {
			newList = state.assignedBreaks.concat(
				breaks.filter((element) => state.assignedBreaks.find((e) => e.id === element.id) === undefined)
			);
		} else {
			newList = state.assignedBreaks.concat(breaks);
		}
		state.assignedBreaks = newList;
	},
	SET_ASSIGNED_BREAK(state, items) {
		let arrayNew = state.assignedBreaks.concat(
			items.filter((element) => state.assignedBreaks.find((e) => e.id === element.id) === undefined)
		);
		state.assignedBreaks = arrayNew;
	},
	REMOVE_ASSIGNED_BREAKS(state, itemId) {
		const ItemIndex = state.assignedBreaks.findIndex((p) => p.id === itemId);
		state.assignedBreaks.splice(ItemIndex, 1);
	},
	CLEAN_ASSIGNED_BREAKS(state) {
		state.assignedBreaks = [];
	},
	ADD_BREAK_CHECKED(state, item) {
		const itemIndex = state.checkedBreaks.findIndex((p) => p.id === item.id);
		if (itemIndex === -1) {
			state.checkedBreaks.push(item);
		}
	},
	SET_BREAK_CHECKED(state, items) {
		state.checkedBreaks = [...items];
	},
	REMOVE_BREAK_CHECKED(state, item) {
		const itemIndex = state.checkedBreaks.findIndex((p) => p.id === item.id);
		if (itemIndex >= 0) {
			state.checkedBreaks.splice(itemIndex, 1);
		}
	},
	REMOVE_ALL_BREAK_CHECKED(state) {
		state.checkedBreaks = [];
	},
};
